import { z } from 'zod';

import { SettingKeysParamSchema } from '../setting-keys-param/setting-keys-param';

/**
 * Which settings to resolve in one request.
 *
 * The settings screen renders a whole group at once and needs each key's stored
 * rows **and** what every allowed scope resolves to — which used to mean one
 * `GET /admin/settings/:key` per row on screen.
 *
 * Deliberately **not** `makeListQuery`: this is not a list. It is not paginated,
 * not sortable, and its cardinality is bounded by the **code** registry rather
 * than by the database, so `page`/`pageSize` are refused rather than silently
 * accepted — offering them would promise paging over a collection that cannot
 * grow at runtime.
 */
export const SettingsDetailsQuerySchema = z
  .object({
    group: z.string().min(1).max(64).optional(),
    subgroup: z.string().min(1).max(64).optional(),
    keys: SettingKeysParamSchema.optional(),
  })
  .strict();

export type SettingsDetailsQuery = z.infer<typeof SettingsDetailsQuerySchema>;
